export default __webpack_public_path__ + "static/media/h1_about_us_bg.92d087b8.png";